import { useCallback, useState } from 'react'

export type PendingInstallationDelete = {
  id: string
  label: string
}

export function useInstallationDeleteConfirm() {
  const [pendingDelete, setPendingDelete] = useState<PendingInstallationDelete | null>(
    null
  )

  const requestDelete = useCallback((item: PendingInstallationDelete) => {
    setPendingDelete(item)
  }, [])

  const clearPendingDelete = useCallback(() => {
    setPendingDelete(null)
  }, [])

  return {
    pendingDelete,
    requestDelete,
    clearPendingDelete,
    isConfirmOpen: pendingDelete !== null,
  }
}
